import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useCustomerGroupSettings = (customerGroupId: string) => {
    return useQuery(queries.customerGroups.detail(customerGroupId)._ctx.settings);
};
